module.exports = __webpack_public_path__ + "static/media/cross-icon.b195082a.svg";